"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  UserIdea: ['user-idea', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75 0.75L15.75 2.25', 'M23.25 8.25L21.643 8.25', 'M9.564 3.35L10.929 4.714', 'M21.936 3.35L20.571 4.714', 'M14.25,11.683V13.5h3V11.683a3.748,3.748,0,1,0-3.911-6.306', 'M14.25 15.75L17.25 15.75', 'M.75,23.25a6.75,6.75,0,0,1,13.5,0Z', 'M3.945,8.781a6.858,6.858,0,0,0,7.643,1.536', 'M3.375 10.875 A4.125 4.125 0 1 0 11.625 10.875 A4.125 4.125 0 1 0 3.375 10.875 Z']],
  Bulb1: ['bulb-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15,17.25v4.5a1.5,1.5,0,0,1-1.5,1.5h-3A1.5,1.5,0,0,1,9,21.75v-4.5', 'M9 20.25L15 20.25', 'M12 0.75L12 2.25', 'M1.5 11.25L3 11.25', 'M3.75 3.75L4.85 4.807', 'M22.5 11.25L21 11.25', 'M20.25 3.75L19.15 4.807', 'M13.5,17.25v-6a1.5,1.5,0,1,1,1.5,1.5H9a1.5,1.5,0,1,1,1.5-1.5v6', 'M8.915,17.25h6.17a6.6,6.6,0,0,0,3.665-6A6.873,6.873,0,0,0,12,4.5a6.873,6.873,0,0,0-6.75,6.754A6.6,6.6,0,0,0,8.915,17.25Z']],
  BrowserIdea: ['browser-idea', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75 8.143L15.75 9.75', 'M8.25 15.75L9.857 15.75', 'M23.25 15.75L21.643 15.75', 'M9.564 10.85L10.929 12.214', 'M21.936 10.85L20.571 12.214', 'M19.5,15.75a3.75,3.75,0,1,0-5.25,3.433V21h3V19.183A3.747,3.747,0,0,0,19.5,15.75Z', 'M14.25 23.25L17.25 23.25', 'M19.5,6.75V1.868A1.128,1.128,0,0,0,18.369.75H1.875A1.122,1.122,0,0,0,.75,1.862V15.381A1.128,1.128,0,0,0,1.881,16.5H5.25', 'M0.75 4.5L19.5 4.5']],
  Bulb: ['bulb', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15,17.25V19.5A1.5,1.5,0,0,1,13.5,21h-3A1.5,1.5,0,0,1,9,19.5V17.25', 'M12 0.75L12 2.25', 'M1.5 11.25L3 11.25', 'M3.75 3.75L4.85 4.807', 'M22.5 11.25L21 11.25', 'M20.25 3.75L19.15 4.807', 'M8.915,17.25h6.17a6.6,6.6,0,0,0,3.665-6A6.873,6.873,0,0,0,12,4.5a6.873,6.873,0,0,0-6.75,6.754A6.6,6.6,0,0,0,8.915,17.25Z', 'M12 21L12 23.25', 'M12 13.5L12 17.25', 'M9.75 11.25L12 13.5 14.25 11.25']],
  HeadIdea: ['head-idea', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25,23.25a1.934,1.934,0,0,0-.75-1.572A11.239,11.239,0,0,0,12,19.321a11.239,11.239,0,0,0-7.5,2.357,1.934,1.934,0,0,0-.75,1.572', 'M10.5 23.071L12 19.321 13.5 23.071', 'M18,6.75a6,6,0,0,0-12,0,5.846,5.846,0,0,0,3.429,5.493V15h5.142V12.243A5.846,5.846,0,0,0,18,6.75Z', 'M12 15L12 16.5', 'M8.938 12L15.062 12', 'M12 12L12 9', 'M14.25 6.75L12 9 9.75 6.75', 'M21.75 6.75L23.25 6.75', 'M21.439 10.189L22.5 11.25', 'M21.439 3.31L22.5 2.25', 'M2.25 6.75L0.75 6.75', 'M2.561 10.189L1.5 11.25', 'M2.561 3.31L1.5 2.25']],
  IdeaStrategy: ['idea-strategy', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.801 20.637 A2.613 2.613 0 1 0 6.027 20.637 A2.613 2.613 0 1 0 0.801 20.637 Z', 'M9.511 18.17H14.488V23.147000000000002H9.511z', 'M23.199 23.147L17.226 23.147 20.212 17.672 23.199 23.147z', 'M15.733,4.585A3.733,3.733,0,1,0,10.507,8V9.811h2.986V8A3.73,3.73,0,0,0,15.733,4.585Z', 'M3.539 15.432L3.539 12.944 20.461 12.944 20.461 15.432', 'M19.775 5.229L21.268 5.229', 'M19.466 8.653L20.521 9.709', 'M19.466 1.806L20.521 0.75', 'M4.225 5.229L2.732 5.229', 'M4.534 8.653L3.478 9.709', 'M4.534 1.806L3.478 0.75', 'M12 9.811L12 14.935']],
  IdeaMessage: ['idea-message', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25,7.5a3,3,0,0,1,3,3v6.75a3,3,0,0,1-3,3h0v3l-5.25-3H8.25a3,3,0,0,1-3-3V10.5a3,3,0,0,1,3-3Z', 'M.75,15.75V7.5a3,3,0,0,1,3-3h0V.75L9,4.5h6.75', 'M15.75,12.75A2.25,2.25,0,1,0,12,14.416V15.75h3V14.416A2.236,2.236,0,0,0,15.75,12.75Z', 'M13.5 15.75L13.5 17.25']],
  TeamShareIdea: ['team-share-idea', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 0.75L12 2.25', 'M4.5 8.25L6.107 8.25', 'M19.5 8.25L17.893 8.25', 'M5.814 3.35L7.179 4.714', 'M18.186 3.35L16.821 4.714', 'M15.75,8.25a3.75,3.75,0,1,0-5.25,3.433V13.5h3V11.683A3.746,3.746,0,0,0,15.75,8.25Z', 'M10.5 15.75L13.5 15.75', 'M16.401 16.875 A2.625 2.625 0 1 0 21.651 16.875 A2.625 2.625 0 1 0 16.401 16.875 Z', 'M23.25,23.25a4.474,4.474,0,0,0-8.449,0', 'M2.349 16.875 A2.625 2.625 0 1 0 7.599 16.875 A2.625 2.625 0 1 0 2.349 16.875 Z', 'M9.2,23.25a4.474,4.474,0,0,0-8.449,0']],
  TeamIdea: ['team-idea', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 18.478 A2.625 2.625 0 1 0 6.000 18.478 A2.625 2.625 0 1 0 0.750 18.478 Z', 'M6.581,23.2A4.5,4.5,0,0,0,.75,22.7', 'M18.000 18.478 A2.625 2.625 0 1 0 23.250 18.478 A2.625 2.625 0 1 0 18.000 18.478 Z', 'M17.511,23.105A4.5,4.5,0,0,1,23.25,22.7', 'M8.625 17.728 A3.375 3.375 0 1 0 15.375 17.728 A3.375 3.375 0 1 0 8.625 17.728 Z', 'M14.723,23.25a6.054,6.054,0,0,0-5.392-.027', 'M15.75,4.6A3.75,3.75,0,1,0,10.5,8.036V9.853h3V8.036A3.747,3.747,0,0,0,15.75,4.6Z', 'M10.5 12.103L13.5 12.103', 'M19.811 5.25L21.311 5.25', 'M19.5 8.689L20.561 9.75', 'M19.5 1.81L20.561 0.75', 'M4.189 5.25L2.689 5.25', 'M4.5 8.689L3.439 9.75', 'M4.5 1.81L3.439 0.75']],
  EyeIdea: ['eye-idea', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.5,9.193A5.988,5.988,0,1,1,17.962,6.765', 'M6.143,11.3A20.816,20.816,0,0,1,1.05,7.659.958.958,0,0,1,1.02,6.3C2.554,4.676,6.763.778,11.764.778c4.2,0,9.192,3.9,11.088,5.517a.977.977,0,0,1,.348.715', 'M15.7 8.143L15.7 9.75', 'M8.2 15.75L9.807 15.75', 'M23.2 15.75L21.593 15.75', 'M9.514 10.85L10.879 12.214', 'M21.886 10.85L20.521 12.214', 'M19.45,15.75a3.75,3.75,0,1,0-5.25,3.433V21h3V19.183A3.746,3.746,0,0,0,19.45,15.75Z', 'M14.2 23.25L17.2 23.25']],
  IdeaSettings: ['idea-settings', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.73,16.6l-1.308.066A1.828,1.828,0,0,1,2.1,13.484l.972-.877a1.83,1.83,0,0,0,0-2.715L2.1,9.015A1.828,1.828,0,0,1,3.422,5.832L4.73,5.9A1.828,1.828,0,0,0,6.649,3.979L6.582,2.671A1.828,1.828,0,0,1,9.765,1.353l.878.972a1.828,1.828,0,0,0,2.714,0l.878-.972a1.828,1.828,0,0,1,3.183,1.318l-.067,1.308A1.828,1.828,0,0,0,19.27,5.9l1.308-.066A1.828,1.828,0,0,1,21.9,9.015l-.972.877a1.83,1.83,0,0,0,0,2.715l.972.877a1.828,1.828,0,0,1-1.319,3.183L19.27,16.6', 'M10.5 22.5L13.5 22.5', 'M17.25,12a5.25,5.25,0,1,0-6.75,5.006V19.5h3V17.006A5.234,5.234,0,0,0,17.25,12Z']],
  LaptopIdea: ['laptop-idea', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 0.75L12 2.25', 'M4.5 8.25L6.107 8.25', 'M19.5 8.25L17.893 8.25', 'M5.814 3.35L7.179 4.714', 'M18.186 3.35L16.821 4.714', 'M6.214,11.25a.941.941,0,0,0-.964.917v6.416a.942.942,0,0,0,.964.917H17.786a.942.942,0,0,0,.964-.917V12.167a.941.941,0,0,0-.964-.917', 'M5.25,19.5,3.382,21.116a1.214,1.214,0,0,0,0,1.768h0a1.335,1.335,0,0,0,.922.366H19.7a1.335,1.335,0,0,0,.922-.366h0a1.214,1.214,0,0,0,0-1.768L18.75,19.5Z', 'M15.75,8.25a3.75,3.75,0,1,0-5.25,3.433V13.5h3V11.683A3.747,3.747,0,0,0,15.75,8.25Z', 'M10.5 15.75L13.5 15.75']]
};
exports["default"] = _default;